
export default function showPrograms() {
    // Show on map - fires upon click on "Show on map" on a single univ page
    // if ($('.show-programs').length > 0) {
        $(document).on('click', '.show-programs', function (e) {
            e.preventDefault();
            var vendor_title = $(this).data("vendor-title").toUpperCase();
            var current_study_type = $(this).data("curr-study-type").toUpperCase();
            var progs = $(this).data("progs");
            var progs_count = $(this).data("progs-count");
            // console.log('LOCS',locations );

            var prog_list = '';

            $.each(progs, function( index, value ) {
                prog_list += '<div class="program">' + value + '</div>';
            });

            var result = '<div class="programs-modal"><div class="programs-modal-header"><h4 class="programs-modal-title">'+ vendor_title + ' - ' + current_study_type +'</h4><div>Related programs (' + progs_count + ')</div></div><div class="programs-modal-body">'+ prog_list +'</div><div class="programs-modal-footer text-center"><button type="button" class="btn btn-default" data-fancybox-close>Close</button></div></div>';

            function runFancyBox(result) {
                var opts = ({
                    // "width": "600",
                    // "min-height": "370",
                    // "modal": true,
                    "touch": false,
                    // "smallBtn" : false,
                    afterShow: function (instance, current) {



                    }
                });
                var instance = $.fancybox.open(result, opts);
            }

            runFancyBox(result);
        });
    // }
}
